import { RelativeTimeText } from '../RelativeTimeText';
import { DateText } from '../DateText';

export interface RelativeTimeToThresholdTextProps {
  showTooltip?: boolean;
  date: number | string | Date;
  thresholdHours: number;
  showTime?: boolean;
}

// Get time formatted as relative time up until a threshold amount of hours or get full formatted date after thresholdHours
// E.g. "7 minutes ago" or "23 hours ago" (if date is < thresholdHours) or "on Jul 26, 2023" (if date is > thresholdHours)
export const RelativeTimeToThresholdText = ({
  date,
  thresholdHours,
  showTooltip = true,
  showTime = false,
}: RelativeTimeToThresholdTextProps) => {
  const timestamp = new Date(date).getTime();

  if ((Date.now() - timestamp) / (1000 * 60 * 60) < thresholdHours) {
    // If the time difference is less than THRESHOLD hours, format relative time
    return <RelativeTimeText date={date} showTooltip={showTooltip} />;
  }

  // If the time difference is more than THRESHOLD hour, format the full date
  return (
    <span>
      on <DateText isLocalTime showTime={showTime} showTooltip={showTooltip} dateStyle="medium" date={timestamp} />
    </span>
  );
};
